import React from 'react';
import flex from '@/css/module/flex.css';
import styles from '@/css/module/new-world.css';
import { loadTables } from '@/actions';
import { Button } from '@trevor/ui-components';
import { useAppDispatch } from '@/store/hooks';

export const EmptyDatabaseMessage = () => {
  const dispatch = useAppDispatch();

  const handleRefreshSchema = () => {
    dispatch(loadTables(true));
  };

  return (
    <div className={`${flex.column} ${styles.welcome}`}>
      <div className={`${flex.row} ${flex.alignItemsCenter}`}>
        <h1>Your database is empty</h1>
      </div>
      <h4 className="margin-top-30">
        Once your database is populated with data, click the button below.
      </h4>
      <Button onClick={handleRefreshSchema} className="margin-top-30">
        <b>Refresh</b>
      </Button>
    </div>
  );
};
